<template>
  <div
      class="order-status-content">
    <div
        class="order-status-bullet"
        :class="'order-status-bullet-' + statusName.replaceAll(' ', '-').toLowerCase()">
    </div>
    <div
        class="order-status-cards"
        shadow="never"
        style="border-radius: 4px !important; border: 1px solid #dee5ec;">
      <div class="order-status-info">
        <div
            class="order-status-name">
          {{ statusName }}
        </div>
        <div class="order-status-subtext">
          <div>
            {{ subtext }}
          </div>
        </div>
        <div class="order-status-datetime">
          {{ dateTimeWithTimezone | moment("MMM DD, YYYY [at] hh:mm A") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import ReturnOrderDetails from "./ReturnOrderDetails.vue";
import "../../../../assets/order_timeline_status.css";

export default {
  name: "ReturnTimelineStatus",
  components: { ReturnOrderDetails },
  props: {
    statusName: {
      type: String,
      default: "Processing",
    },
    subtext: {
      type: String,
      default: "doorbell",
    },
    dateTime: {
      type: String,
      default: "doorbell",
    },
  },
  data() {
    const CLOSED = "Closed",
      DRAFT_CREATED = "Draft Created",
      LABEL_CREATED = "Label Created",
      WAITING_FOR_UPDATES = "Waiting for Updates",
      MANUAL_TRACKING = "Manual Tracking",
      RETURN_SHIPPED = "Return Shipped",
      MANUAL_REFUND = "Manual Refund",
      PAID = "Paid",
      CANCELLED = "Cancelled";
    return {
      statusNameBullet: "",
      CANCELLED,
      CLOSED,
      DRAFT_CREATED,
      LABEL_CREATED,
      WAITING_FOR_UPDATES,
      MANUAL_REFUND,
      MANUAL_TRACKING,
      RETURN_SHIPPED,
      PAID,
      dateTimeWithTimezone: "",
      visible: false,
    };
  },
  mounted() {
    let tz = this.$store.getters["ui/currentTimezone"];
    this.dateTimeWithTimezone = this.$moment
      .tz(this.dateTime, tz)
      .format("MMM DD, YYYY [at] hh:mm A");
  },
  methods: {
    moment,
  },
};
</script>

